/**
 * Fordonsbestånd — export enligt backend-mall (CSV / Excel).
 */

import api from '../api/client';

const base = '/api/vehicles';

export async function downloadVehicleRegisterExport(opts: {
  format: 'xlsx' | 'csv';
  organizationId?: string;
}): Promise<void> {
  const params = new URLSearchParams({ format: opts.format });
  if (opts.organizationId) params.set('organizationId', opts.organizationId);
  const res = await api.get<Blob>(`${base}/export/vehicle-register?${params}`, {
    responseType: 'blob',
  });
  const cd = res.headers['content-disposition'] as string | undefined;
  let filename = opts.format === 'csv' ? 'fordonsbestand.csv' : 'fordonsbestand.xlsx';
  if (cd) {
    const m = /filename="([^"]+)"/.exec(cd);
    if (m?.[1]) filename = m[1];
  }
  const url = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export async function downloadCarInfoVehicleReportExport(opts: {
  organizationId?: string;
}): Promise<void> {
  const params = new URLSearchParams();
  if (opts.organizationId) params.set('organizationId', opts.organizationId);
  const query = params.toString();
  const res = await api.get<Blob>(`${base}/export/carinfo-vehicle-report${query ? `?${query}` : ''}`, {
    responseType: 'blob',
  });
  const cd = res.headers['content-disposition'] as string | undefined;
  let filename = 'fordonsrapport_carinfo.xlsx';
  if (cd) {
    const m = /filename="([^"]+)"/.exec(cd);
    if (m?.[1]) filename = m[1];
  }
  const url = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
